import _ from 'lodash';
import { CustomOption } from '../store/cloud-run-prep/run-setup.state';

export class GSSKitsSortUtilities {

    /**
     * Logic to sort other kit array
     * @param kits Other array e.g. Library Prep Kits
     */
    public static sortKits(kits: any[]): any[] {
        return _.sortBy(kits, kit => (kit.displayName || kit.name).toUpperCase());
    }

    /**
     * Logic to sort custom option array
     * @param kits Custom option array to be sorted
     */
    public static sortCustomOptions(kits: CustomOption[]): CustomOption[] {
        return _.sortBy(kits, kit => (kit.text).toUpperCase());
    }
  }
